// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styled_wrapper__10sO6"};